import api from "./axios";

const BASE = "/auth"; // ⚠️ عدّل ده لو الـ prefix عندك مختلف

export const teacherAccountsAPI = {
  list: () => api.get(`${BASE}/teachers/`).then((r) => r.data),

  get: (teacherId) =>
    api.get(`${BASE}/teachers/${teacherId}/`).then((r) => r.data),

  create: (payload) =>
    // payload: { email, full_name, password, phone_number?, specialization?, bio? }
    api.post(`${BASE}/teachers/create/`, payload).then((r) => r.data),

  update: (teacherId, payload) =>
    // payload: { full_name?, phone_number?, specialization?, bio?, is_active?, new_password? }
    api.put(`${BASE}/teachers/${teacherId}/`, payload).then((r) => r.data),

  remove: (teacherId) =>
    api.delete(`${BASE}/teachers/${teacherId}/`).then((r) => r.data),
};